var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.526,
    height: 34.526,
    viewBox: "0 0 34.526 34.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M16.753,13.5H31.39a3.253,3.253,0,0,1,3.253,3.253V31.39a3.253,3.253,0,0,1-3.253,3.253H16.753A3.253,3.253,0,0,1,13.5,31.39V16.753A3.253,3.253,0,0,1,16.753,13.5Z",
    transform: "translate(0.884 0.884)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M7.879,24.142H6.253A3.253,3.253,0,0,1,3,20.89V6.253A3.253,3.253,0,0,1,6.253,3H20.89a3.253,3.253,0,0,1,3.253,3.253V7.879",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCopy);
export default __webpack_public_path__ + "static/media/feather-copy.4f014e381ad4b0e415b268627c2b7605.svg";
export { ForwardRef as ReactComponent };